var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('DashboardCollab',{attrs:{"filter":['owner'],"compact":"owner","title":_vm.$t('learningDesign.myLearningDesigns'),"action-new-project":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }